module.exports = __webpack_public_path__ + "./images/personImg.7d09b6.jpg";